module.exports = __webpack_public_path__ + "img/kiin.4a275ce4.jpg";